import { WuiIcon } from '@wui/react';
import { useEffect, useRef, useState } from 'react';

import css from './style.module.scss';

export const PulseLoader = () => {
  const [animationCount, setAnimationCount] = useState(0);

  const timeout = useRef<ReturnType<typeof setTimeout>>();
  // Restart animation sequence on interval
  useEffect(() => {
    timeout.current = setTimeout(() => setAnimationCount(animationCount + 1), 1700);
    return () => timeout.current && clearTimeout(timeout.current);
  });

  return (
    <div className={css.pulseLoader} key={animationCount} data-test="show-pulse-loader">
      <div className={css.halo} />
      <WuiIcon name="player-play" className={css.play} size="lg" />

      <div className={css.dots}>
        <div className={css.topLeft} />
        <div className={css.top} />
        <div className={css.topRight} />

        <div className={css.left} />
        <div />
        <div className={css.right} />

        <div className={css.bottomLeft} />
        <div className={css.bottom} />
        <div className={css.bottomRight} />
      </div>
    </div>
  );
};
